<template lang="pug"
src='./floor-roofs.pug'>

</template>

<script>
import saveBtn from '@/common/components/saveBtn.vue'
import floorImageReferenceModal from './pops/floorReferenceSvg.vue'
import easyBtn from 'Common/components/easy-btn.vue'
import imgIcon from '@/common/img/baseline-clear-24px.svg'
import _ from 'lodash'

export default {
	name: 'floors-roofs',
	props: ['project', 'control', 'readonly', 'findControlTextByKey'],
	components: {
		saveBtn,
		easyBtn,
		floorImageReferenceModal,
		atticTotalArea: '',
		projType: {}
	},
	data () {
		return {
			floors: [
				{
					title: 'Area over enclosed crawlspace',
					field: 'overEncCrawlSpaceArea',
					type: 'overEncCrawlSpaceType'
				},
				{
					title: 'Area over enclosed garage',
					field: 'overEncGarageArea',
					type: 'overEncGarageType'
				},
				{
					title: 'Area over open space <br />(exposed)',
					field: 'overOpenSpaceArea',
					type: 'overOpenSpaceType'
				},
				{
					title: 'Area of Slab <br />(not counting garage)',
					field: 'slabArea',
					type: 'slabType'
				},
				{
					title: 'Interior floor areas <br /> (conditioned above & below)',
					field: 'upperOverCondSpaceArea',
					type: 'upperOverCondSpaceType'
				},
				{
					title: 'Total Conditioned Floor Area',
					field: 'totalCondArea',
					type: 'totalCondType'
				}
			],
			wichInfo: '',
			popUp: false,
			atticTotalArea: '123',
			imgIconDel: imgIcon
		}
	},
	created () {
		this.resultFloorAreas()
		this.projType = process.env.PROJTYPE

		if (_.isNil(this.project.floorsRoofs.roofs)) {
			console.log('Floors is null')
			this.project.floorsRoofs.roofs = []
			this.addRoof()
		}
	},
	methods: {
		addRoof () {
			this.project.floorsRoofs.roofs.push(
				{
					rebuiltAttic: '',
					area: 0,
					slope: '0.0',
					orient: 0,
					depth: ''
				}
			)
		},
		deleteRoof (index) {
			this.project.floorsRoofs.roofs.splice(index, 1)
		},
		showModalFromInfo (value) {
			this.popUp = true
			this.wichInfo = value
			// EventBus.$emit('open-floors-svg-reference-popUp', value)
		},
		resultFloorAreas () {
			let overEncCraw = Number(this.project.floorsRoofs.overEncCrawlSpaceArea)
			let overEncGarage = Number(this.project.floorsRoofs.overEncGarageArea)
			let overOpenSpace = Number(this.project.floorsRoofs.overOpenSpaceArea)
			let totalIntAreas = Number(this.project.floorsRoofs.totalIntAreas)
			let slabArea = Number(this.project.floorsRoofs.slabArea)
			let res = Number(overEncCraw + overEncGarage + overOpenSpace + slabArea)
			res = (this.project.numStories > 1) ? res + totalIntAreas : res
			this.project.floorsRoofs.upperOverCondSpaceArea = res
			this.project.floorsRoofs.totalCondArea = res
			this.calculateTotalArea()
		},
		hideModal () {
			// this.$refs.contextualHelp.hide()
			this.popUp = false
			this.wichInfo = ''
		},
		calculateTotalArea () {
			if (!this.project.floorsRoofs.typRoofSlope) { this.project.floorsRoofs.typRoofSlope = 0 }

			let resA = this.project.floorsRoofs.totalCondArea

			if (this.project.numStories > 1) {
				resA = resA - Number(this.project.floorsRoofs.totalIntAreas)
			}

			let vault1 = Number(this.project.floorsRoofs.vaults[0].area)
			let vault2 = Number(this.project.floorsRoofs.vaults[1].area)
			let vault3 = Number(this.project.floorsRoofs.vaults[2].area)
			let vault4 = Number(this.project.floorsRoofs.vaults[3].area)
			let resV = vault1 + vault2 + vault3 + vault4
			let res = resA - resV
			this.atticTotalArea = (res > 0) ? res : 0
			// console.debug(`project.floorsRoofs.vaults is ${this.project.floorsRoofs.vaults[0].area}`)
		},
		typSlopeChange (vault) {
			console.log('vault', vault)
			vault.typSlope = false
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/take-off-tool/tabs-components/floors-roofs.vue